import React, { useState } from "react";
import { getUserDetails } from "../../utils/auth";
import EditPopup from "../Shared/EditUserPopup";
import { getUserId } from "../../utils/auth";

const User_Profile = () => {
  function capitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  
  const [userData] = useState({
    ...getUserDetails(),  // Retrieve details from localStorage
    id: getUserId()
  });
  const [showPopup, setShowPopup] = useState(false);

  const popUp = () => {
    if (userData) {
      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  if (!userData) {
    return <p>No user data available</p>;
  }

  return (
    <div>
      <div className="dashboard_grey_section">
        <h1 className="font-lg mb-4">My Profile</h1>

      

        <div className="profile-about profile_about_custom dashboard-bg-box">
          <div className="row">
            <div className="col-xxl-7">
              {/* <div className="dashboard-title mb-3">
                <div className="font-md fw-semibold">Profile About</div>
              </div> */}

              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Name :</td>
                      <td>{userData.first_name && userData.last_name ? `${capitalize(userData.first_name)} ${capitalize(userData.last_name)}` : "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Username :</td>
                      <td>{userData.username || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Email :</td>
                      <td>{userData.email || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Gender :</td>
                      <td>{userData.gender ? `${capitalize(userData.gender)}` : "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Unique Code :</td>
                      <td>{userData.ucode || "N/A"}</td>
                    </tr>
                    {/* <tr>
                      <td>Date of Birth :</td>
                      <td>{userData.date_of_birth || "N/A"}</td>
                    </tr> */}
                    <tr>
                      <td>Phone Number :</td>
                      <td>{userData.mobile || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Address :</td>
                      <td>
                        {userData.address && typeof userData.address === 'object' ? (
                          <>
                            <div>Street: {userData.address.street_address || 'N/A'}</div>
                            <div>State: {userData.address.state || 'N/A'}</div>
                            <div>Pincode: {userData.address.pincode || 'N/A'}</div>
                          </>
                        ) : (
                          'N/A'
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="text-end mt-3">
                <button
                  onClick={popUp}
                  className="btn-assessment font-xss btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                >
                  Edit Profile <i className="fa-solid fa-right-long icon ms-2"></i>
                </button>
              </div>
              {showPopup && (
                <EditPopup 
                  userData={userData} 
                  closePopup={closePopup}
                />
              )}
            </div>
            {/* <div className="col-xxl-5">
              <div className="profile-image">
                <img
                  src={userData.profilePicture || "../assets/images/inner-page/dashboard-profile.png"}
                  className="img-fluid blur-up lazyloaded"
                  alt="Profile"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default User_Profile;
